"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchModal = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const useDebounce_1 = __importDefault(require("../../../common/helpers/Hooks/useDebounce"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ListItem_1 = __importDefault(require("../Interactive/Tiles/ListItem"));
const SearchWrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100%;
  z-index: 1110;
  background-color: white;
  overflow: hidden;
  padding-top: 4vmin;
  z-index: 3;

  @media (orientation: portrait) {
    justify-content: flex-end;
  }
`;
const SearchInputWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  height: 8vmin;
  width: 100%;
  max-width: 800px;
  margin: 3vmin;
  background: rgba(235, 231, 230, 1);
  border-radius: 100px;
  overflow: hidden;

  @media (orientation: portrait) {
    max-width: 80%;
    order: 2;
  }

  .MuiSvgIcon-root {
    font-size: 5vmin;
    position: initial;
    text-align: center;

    @media (min-width: 600px) {
      font-size: 4vmin;
    }
  }

  .MuiInputBase-adornedStart {
    &:before,
    &:after {
      border-bottom: none !important;
    }
  }

  input {
    font-size: 3vmin;
    padding-top: 8px;
    padding-left: 20px;
  }

  .MuiFormControl-root,
  .MuiInputBase-root {
    height: 100%;
    width: 100%;
  }
`;
const SearchResults = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  overflow: auto;
  padding: 16px;
  max-width: 1000px;
  width: 100%;

  @media (orientation: portrait) {
    max-width: 80%;
  }

  .list-item {
    width: 100%;
  }
`;
const NoResultsMessage = (0, styled_components_1.default)(material_1.Typography) `
  text-align: center;
  color: gray;
  margin-top: 20px;
`;
const StyledCloseButton = (0, styled_components_1.default)(material_1.IconButton) `
  position: absolute;
  top: 4vmin;
  right: 3vmin;
  background-color: rgba(235, 231, 230, 1);
  color: black;
  width: 5vmin;
  height: 5vmin;

  @media (orientation: portrait) {
    top: initial;
    bottom: 4.5vmin;
  }

  &:hover {
    background-color: rgba(235, 231, 230, 1);
  }
`;
const SearchModal = (props) => {
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const [results, setResults] = (0, react_1.useState)([]);
    const debouncedSearchTerm = (0, useDebounce_1.default)(searchTerm, 400);
    const initialSearchResults = (0, react_1.useMemo)(() => {
        const activitiesResults = props.unfilteredActivities.map((activity) => ({
            content: activity,
            type: 'activity',
        }));
        const processDirectoryAndOffers = (items) => {
            return items.flatMap(node => {
                const nodeType = Object.keys(node)[0];
                if (nodeType === 'folder') {
                    return processDirectoryAndOffers(node[nodeType].children);
                }
                else {
                    return [{ content: node[nodeType], type: node[nodeType].type }];
                }
            });
        };
        const directoryAndOffersResults = processDirectoryAndOffers([...props.directoryData, ...props.offers]);
        return [...activitiesResults, ...directoryAndOffersResults];
    }, [props.unfilteredActivities, props.directoryData, props.offers]);
    (0, react_1.useEffect)(() => {
        const input = document.querySelector('#main-search-input');
        if (input) {
            input.focus();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (debouncedSearchTerm) {
            const filteredResults = initialSearchResults.filter(item => {
                if (Object.prototype.hasOwnProperty.call(item.content, 'text')) {
                    if (item.content.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        item.content.text.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            });
            setResults(filteredResults);
        }
        else {
            setResults([]);
        }
    }, [debouncedSearchTerm]);
    const handleOpenDialog = (content) => {
        props.updateStore('isDialogOpen', true);
        props.updateStore('dialogContent', content);
    };
    return (react_1.default.createElement(SearchWrapper, null,
        react_1.default.createElement(StyledCloseButton, { "aria-label": "close search modal", onClick: props.onClose },
            react_1.default.createElement(Close_1.default, null)),
        react_1.default.createElement(SearchInputWrapper, { className: "search-input" },
            react_1.default.createElement(material_1.TextField, { id: "main-search-input", value: searchTerm, onChange: e => setSearchTerm(e.target.value), role: "searchbox", variant: "filled", placeholder: i18n_js_1.default.t('dictionary.search'), InputProps: {
                    startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                        react_1.default.createElement(Search_1.default, null))),
                    endAdornment: (react_1.default.createElement(react_1.default.Fragment, null, searchTerm.length > 0 && (react_1.default.createElement(InputAdornment_1.default, { "data-testid": "clear-button", position: "end", onClick: () => setSearchTerm('') },
                        react_1.default.createElement(Close_1.default, null))))),
                } })),
        results.length > 0 && (react_1.default.createElement(SearchResults, { className: "search-results" }, results.map(item => (react_1.default.createElement(ListItem_1.default, { key: (0, react_uid_1.uid)(item.content), content: item.content, withLazyLoad: false, onListItemClick: handleOpenDialog }))))),
        results.length === 0 && searchTerm && (react_1.default.createElement(NoResultsMessage, { variant: "body1" }, i18n_js_1.default.t('no_results')))));
};
exports.SearchModal = SearchModal;
const mapStoreToProps = store => ({
    unfilteredActivities: store.getValue('unfilteredActivities'),
    directoryData: store.getValue('directory'),
    offers: store.getValue('offers'),
    showSearch: store.getValue('showSearch'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.SearchModal);
